import { render, staticRenderFns } from "./AutocompleteCategoryNewRecipe.vue?vue&type=template&id=22bcc2ca&scoped=true&"
import script from "./AutocompleteCategoryNewRecipe.vue?vue&type=script&lang=js&"
export * from "./AutocompleteCategoryNewRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bcc2ca",
  null
  
)

export default component.exports